import styled from 'styled-components';
import { Button } from 'top-component-library';

export const StyledButton = styled(Button)`
  height: auto;
  background: var(--color-button-landing-page__regular);
  border-color: var(--color-button-landing-page__regular);
  border: none;
  border-radius: var(--button__border-radius);
  white-space: normal;
  color: var(--bose-landing-button__text);

  &.ant-btn {
    padding: 0.75rem 3rem 0.75rem 3rem;
  }

  &:hover {
    background: var(--color-button-landing-page__regular);
    color: var(--bose-landing-button__text);
    opacity: 1;
    filter: brightness(85%);
  }
`;
